import Ext from "Ext";
import GenericSelectorPanel from "./at_generic_selector_panel";
import SelectionHelper from "./selectionHelpers/at_selection_helper";
import GenericSelectorTreePropertiesController from "./GenericSelectorTreePropertiesController";
import SimpleListSelectorTree from "./at_simple_list_selector_tree";

/**
 * Selector panel for simple list.
 *
 * Depends on:
 * <code>/js/controls/selectorControls/at_generic_selection_panel.js</code>
 * <code>/js/controls/selectorControls/at_simple_list_selector_tree.js</code>
 * <code>/js/message_resources.js</code> with prefixes "common"
 *
 * @constructor
 */
const SimpleSelectorPanel = Ext.extend(GenericSelectorPanel, {
    allItemsOptionValue: true,
    customOptionValue: false,

    selectorTreeCtor: SimpleListSelectorTree,
    isMarkAllSelectedIsEmpty: true,

    /**
     * @cfg {Function} propertiesControllerCtor constructor for a {@link AT.GenericSelectorTreePropertiesController} implementation
     */
    propertiesControllerCtor: GenericSelectorTreePropertiesController,
    propertiesController: null,

    initComponent: function() {
        this.propertiesController = new this.propertiesControllerCtor();
        SimpleSelectorPanel.superclass.initComponent.call(this);
    },

    createComponents: function() {
        SimpleSelectorPanel.superclass.createComponents.call(this);

        this.selectAllButton.on("click", this.selectorTree.selectAll, this.selectorTree);
        this.clearButton.on("click", this.selectorTree.selectNone, this.selectorTree);
    },

    createSelectionFilters: function()
    {
        SimpleSelectorPanel.superclass.createSelectionFilters.call(this);

        var self = this;
        this.showInactiveCheckbox.on("check", function(e, checked) {
            self.filterTreeNodes(checked);
        });
    },

    getSelection: function() {
        return this.selectorTree.getSelection();
    },

    isTooltipEnabled: function()
    {
        return this.isCustomOptionSelected() &&
               this.getSelection().length != 0;
    },

    getTooltipForCustomOption: function() {
        var context = this;
        return this.selectionHelper.getListDescription(this.getSelection(), function(item) {return context.getSelectionHelper().getListDescriptionItem(item)});
    },


    getDescription: function(selectionHelper) {
        this.selectionHelper.itemNounSingularKey = this.labelItemNounSingularKey;
        this.selectionHelper.itemNounPluralKey= this.labelItemNounPluralKey;
        return selectionHelper.getDescription(this.getSelection());
    },

    makeSelectionHelper: function() {
        this.selectionHelper = new SelectionHelper({
                                                       propertiesController: this.selectorTree.nodeHelper.propertiesController,
                                                       itemNounSingularKey: this.labelItemNounSingularKey,
                                                       itemNounPluralKey: this.labelItemNounPluralKey,
                                                       showInactiveCount: true,
                                                       showSingleItemInactiveText: false,
                                                       noItemsSelectedKey: this.labelNoItemsSelectedKey,
                                                       maxCharacters: this.labelMaxChars,
                                                       useNameForSingleItem: this.labelUseNameForSingleItem
                                                   });
    },

    isEmptySelection: function() {
        return this.getSelection().length == 0;
    }
});

Ext.reg("at_simple_selector_panel", SimpleSelectorPanel);

export default SimpleSelectorPanel;


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/at_simple_selector_panel.js